import { DateTime } from 'luxon';

export class IstatFilterModel {
  profile: number | null = null;
  year: number | null = null;
  month: number | null = null;
  day: DateTime | null = null;
  startDate: DateTime | null = null;
  endDate: DateTime | null = null;
}
